export default __webpack_public_path__ + "static/media/dapps4.30c14958.jpg";